// src/lib/globals.js

let courseName = null;

// Function to get the current course name
export const getCourseName = () => {
  return courseName;
};

// Function to set the course name
export const setCourseName = (name) => {
  courseName = name;
};
